<template>
  <div>
    <v-card
      class="d-flex flex-column text-center justify-center align-center pa-3 py-10 rounded-lg shadow-sm"
      style="max-width: 700px; width: 100%"
      flat
    >
      <!-- <v-btn
        @click="openDialog"
        depressed 
        color="primary"
        class="text-none rounded-pill font-rubik px-12 py-6 mb-8"
        aria-label="Calcula el teu percentil"
        style="letter-spacing: unset; font-size: 1rem;"
      >
        <v-icon class="mr-3" color="white">mdi-chart-line</v-icon>
        Calcula el teu percentil
      </v-btn> -->

      <div
      @click="openDialog"
      >
      <v-badge 
        content="Sabràs en quin % et trobes"
        color="#ffa202"
        class="font-rubik font-weight-medium mx-auto black--text top-grades-badge"
        offset-x="180"
        offset-y="10"
      >
        <v-chip
          class="font-rubik font-weight-medium pl-6 pr-8 mx-auto elevation-0"
          large 
          color="primary"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-2 lucide lucide-graduation-cap-icon lucide-graduation-cap"><path d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z"/><path d="M22 10v6"/><path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"/></svg>

          <span class="font-weight-medium white--text">
            Descobreix si entraràs a la carrera que desitges
          </span>
        </v-chip>
      </v-badge>
      </div>
    </v-card>

    <!-- Dialog -->
    <v-dialog v-model="dialog" max-width="900">
      <v-card class="pa-6">
        <v-card-title class="font-weight-bold font-rubik">
          Calcula el teu percentil
        </v-card-title>
        
        <v-card-text>
          <!-- Explicació del funcionament -->
        
            <div class="font-weight-bold mb-2">Com funciona?</div>
            <div class="text-body-2">
              <p class="mb-2">
                📊 <strong>Calculem el teu percentil</strong>: Compararem la teva nota de batxillerat amb la d'altres estudiants que volen accedir a la mateixa carrera que tu.
              </p>
              <p class="mb-2">
                📧 <strong>Rebràs els resultats per correu</strong>: En uns dies t'enviarem un informe personalitzat.
              </p>
             
            </div>

          <v-form ref="form" v-model="valid" class="mt-6">
            <!-- Email -->
            <v-text-field
              v-model="formData.email"
              label="Correu electrònic*"
              type="email"
              outlined
              dense
              :rules="emailRules"
              required
              class="mb-4"
            ></v-text-field>

            <!-- Nota bachillerato -->
            <v-text-field
              v-model="formData.nota"
              label="Nota de batxillerat*"
              type="number"
              min="0"
              max="10"
              step="0.01"
              outlined
              dense
              :rules="notaRules"
              required
              hint="Introdueix la teva nota mitjana de batxillerat (0-10)"
              class="mb-4"
            ></v-text-field>

            <!-- Búsqueda de carreras -->
            <v-autocomplete
              v-model="formData.carreras"
              :items="carrerasOptions"
              :search-input.sync="carrerasSearch"
              @update:search-input="searchCarreras"
              label="Carreres d'interès*"
              outlined
              dense
              multiple
              chips
              deletable-chips
              small-chips
              :rules="carrerasRules"
              required
              hint="Busca i selecciona les carreres que t'interessen"
              class="mb-4"
              :item-text="getItemText"
              :item-value="getItemValue"
              return-object
              no-filter
            >
              <template v-slot:item="{ item }">
                <div class="d-flex align-center w-100">
                  <span class="font-rubik font-weight-bold primary px-2 py-1 rounded white--text mr-3"
                        style="font-size: 12px; min-width: 45px; text-align: center">
                    {{ item.university_acronym }}
                  </span>
                  <span class="font-rubik flex-grow-1">{{ item.career_name }}</span>
                  <span class="font-rubik font-weight-bold ml-2" style="font-size: 14px">
                    {{ item.grade ? item.grade.toFixed(2) : 'N/A' }}
                  </span>
                </div>
              </template>
              
              <template v-slot:selection="{ item }">
                <v-chip small class="ma-1">
                  <span class="font-weight-bold mr-1">{{ item.university_acronym }}</span>
                  {{ item.career_name.length > 30 ? item.career_name.substring(0, 30) + '...' : item.career_name }}
                </v-chip>
              </template>
            </v-autocomplete>

            <!-- Checkbox de permisos -->
            <v-checkbox
              v-model="formData.allowEmails"
              class="mt-2"
            >
              <template v-slot:label>
                <span style="font-size: 12px;"> 
                  Accepto rebre correus amb els meus resultats i informació relacionada amb educació universitària.
                </span>
              </template>
            </v-checkbox>

            <v-alert
              v-if="error"
              type="error"
              text
              class="mt-4"
            >
              {{ error }}
            </v-alert>

            <v-alert
              v-if="success"
              type="success"
              text
              class="mt-4"
            >
              Dades enviades correctament! Rebràs els resultats al teu correu en uns dies.
            </v-alert>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-btn
            text
            @click="closeDialog"
            :disabled="loading"
            class="font-rubik font-weight-medium text-none"
          >
            Cancel·lar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="!valid || !formData.allowEmails || loading"
            :loading="loading"
            @click="submitForm"
            class="text-none px-12 font-rubik font-weight-medium"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'TopGrades',
  data() {
    return {
      dialog: false,
      valid: false,
      loading: false,
      loadingCarreras: false,
      carrerasSearch: '',
      carrerasOptions: [],
      error: '',
      success: false,
      formData: {
        email: '',
        nota: '',
        carreras: [],
        allowEmails: true
      },
      emailRules: [
        v => !!v || 'El correu és obligatori',
        v => /.+@.+\..+/.test(v) || 'El correu ha de ser vàlid'
      ],
      notaRules: [
        v => !!v || 'La nota és obligatòria',
        v => (v >= 0 && v <= 10) || 'La nota ha d\'estar entre 0 i 10',
        v => !isNaN(parseFloat(v)) || 'Ha de ser un número vàlid'
      ],
      carrerasRules: [
        v => v.length > 0 || 'Selecciona almenys una carrera'
      ]
    }
  },
  methods: {
    openDialog() {
      this.dialog = true;
      this.resetForm();
    },
    closeDialog() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm() {
      this.formData = {
        email: '',
        nota: '',
        carreras: [],
        allowEmails: true
      };
      this.error = '';
      this.success = false;
      this.carrerasOptions = [];
      this.carrerasSearch = '';
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    getItemText(item) {
      return `${item.university_acronym} - ${item.career_name}`;
    },
    getItemValue(item) {
      return item.career_name;
    },
    async searchCarreras(query) {
      if (!query || query.length < 2) {
        this.carrerasOptions = [];
        return;
      }

      this.loadingCarreras = true;
      try {
        // Utilitzem l'endpoint de notes-de-tall per obtenir dades completes
        const response = await this.axios.get(`/notes-de-tall/${encodeURIComponent(query)}/0/Totes les universitats/grade_pau/0`);
        console.log(">>>", response.data)
        this.carrerasOptions = response.data.resultat || [];
      } catch (error) {
        console.error('Error buscant carreres:', error);
        this.carrerasOptions = [];
      } finally {
        this.loadingCarreras = false;
      }
    },
    async submitForm() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.loading = true;
      this.error = '';
      this.success = false;

      try {
        const payload = {
          email: this.formData.email.trim(),
          nota: parseFloat(this.formData.nota),
          carreras: this.formData.carreras.map(carrera => ({
            career_name: carrera.career_name,
            career_id: carrera.career_id,
            university_acronym: carrera.university_acronym
          })),
          allowEmails: this.formData.allowEmails
        };

        await this.axios.post('/user-carreras', payload);
        
        this.success = true;
        setTimeout(() => {
          this.closeDialog();
        }, 2000);

      } catch (error) {
        console.error('Error enviant dades:', error);
        this.error = error.response?.data?.message || 'Error en enviar les dades. Torna-ho a provar.';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.headline {
  color: #252549 !important;
}

/* White text on the orange badge fails WCAG contrast (2.0:1) */
.top-grades-badge >>> .v-badge__badge {
  color: #3D2200 !important;
}
</style>
